// Lucide icons, stroke-width 1.75, currentColor — the whole icon system.
// The design uses no emoji: icons carry the visual load (README "Iconography").
import {
  ArrowLeftRight,
  Car,
  Calendar,
  CircleCheck,
  CircleHelp,
  Fish,
  Flag,
  KeyRound,
  Landmark,
  Lock,
  Mail,
  MapPin,
  MessageSquare,
  Moon,
  Phone,
  Plane,
  User,
  Users,
  Waves,
  type LucideIcon,
} from 'lucide-react';

// Every icon name referenced by the data layer or the UI, mapped to lucide.
const ICONS = {
  // data layer (content.ts) — Fact / OpenQuestion / TravelMode icons
  calendar: Calendar,
  moon: Moon,
  pin: MapPin,
  bank: Landmark,
  car: Car,
  plane: Plane,
  swap: ArrowLeftRight,
  help: CircleHelp,
  // hero trio + UI
  fish: Fish,
  waves: Waves,
  flag: Flag,
  users: Users,
  user: User,
  lock: Lock,
  mail: Mail,
  key: KeyRound,
  phone: Phone,
  message: MessageSquare,
  check: CircleCheck,
} satisfies Record<string, LucideIcon>;

export type IconKey = keyof typeof ICONS;

interface IconProps {
  name: IconKey;
  size?: number;
  className?: string;
  color?: string;
  'aria-hidden'?: boolean;
  strokeWidth?: number;
  style?: React.CSSProperties;
}

export function Icon({ name, size = 24, strokeWidth = 1.75, ...rest }: IconProps) {
  const Cmp = ICONS[name];
  return <Cmp size={size} strokeWidth={strokeWidth} aria-hidden {...rest} />;
}
